import { render, staticRenderFns } from "./AttachmentTypologyEdit.vue?vue&type=template&id=6c1816f7&"
import script from "./AttachmentTypologyEdit.vue?vue&type=script&lang=js&"
export * from "./AttachmentTypologyEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports